import React, { useState } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';

import LeftSideLayout from 'components/organisms/layouts/LeftSideLayout';
import { PointConversionsList } from 'components/organisms/wall/pointConversions/PointConversionsList';
import BdcInvoiceCompanyHistory from 'components/organisms/wall/BdcInvoiceCompany/BdcInvoiceCompanyHistory';
import BdcWinsDemand from './bdcWinsDemand/BdcWinsDemand';
import { usePointConversionsPage } from 'hooks/pointConversions/usePointConversionsPage';
import { WALL_TYPE } from 'constants/general';
import coreStyle from 'sass-boilerplate/stylesheets/style.module.scss';
import tableStyle from 'sass-boilerplate/stylesheets/components/tables/Table.module.scss';
import postTabStyle from 'sass-boilerplate/stylesheets/components/wall/PostTabs.module.scss';
import pointsStyle from 'sass-boilerplate/stylesheets/components/launch/Points.module.scss';
import buttonStyle from 'assets/style/common/Button.module.scss';

const SuperAdminWinsPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [historyVersion, setHistoryVersion] = useState(0);
  const [formVersion, setFormVersion] = useState(0);
  const [exportRows, setExportRows] = useState<any[]>([]);
  const [exportColumns, setExportColumns] = useState<Array<{ field: string; headerName: string }>>([]);
  const [, setFileName] = useState('');
  const conversions = usePointConversionsPage();

  const exportToExcel = () => {
    const rows = exportRows.map(row => {
      const output: Record<string, unknown> = {};
      exportColumns.forEach(column => { output[column.headerName] = row[column.field]; });
      return output;
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(rows), 'Historique');
    const data = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    FileSaver.saveAs(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 'Historique_des_WINS.xlsx');
  };

  return (
    <LeftSideLayout theme={WALL_TYPE} hasUserIcon>
      <div className={`${tableStyle.table} ${coreStyle.px3}`}>
        <Tabs className={postTabStyle.postTab} onSelect={index => {
          setActiveTab(index);
          setExportRows([]);
          setExportColumns([]);
          if (index === 1) setHistoryVersion(version => version + 1);
          if (index === 2) setFormVersion(version => version + 1);
        }}>
          <div className={pointsStyle.pointsTabsHeader}>
            <TabList className={pointsStyle.pointsTabList}>
              <Tab selectedClassName={postTabStyle.postTabItemSelected}>Historique des conversions</Tab>
              <Tab selectedClassName={postTabStyle.postTabItemSelected}>Historique des BDC</Tab>
              <Tab selectedClassName={postTabStyle.postTabItemSelected}>Plus de Wins</Tab>
            </TabList>
            {activeTab !== 2 && <button type="button" className={buttonStyle.secondary} onClick={exportToExcel} disabled={!exportRows.length}>
              Export excel
            </button>}
          </div>
          <TabPanel>
            <PointConversionsList {...conversions} canResolve={false}
              setDataExport={setExportRows} setExportColDefs={setExportColumns} setFileName={setFileName} />
          </TabPanel>
          <TabPanel>
            <BdcInvoiceCompanyHistory refreshKey={historyVersion}
              setDataExport={setExportRows} setExportColDefs={setExportColumns} setFileName={setFileName} />
          </TabPanel>
          <TabPanel>
            <BdcWinsDemand key={formVersion} preferCompanyRoot onCreated={() => setHistoryVersion(version => version + 1)} onRewardsRedirectClick={() => {}} />
          </TabPanel>
        </Tabs>
      </div>
    </LeftSideLayout>
  );
};

export default SuperAdminWinsPage;
